import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.9);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const goToPricing = () => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-233" data-mp="1v9xlluai32o3">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 40
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 40
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-gold/40 bg-ink/95 px-4 py-3 backdrop-blur-[10px] lg:hidden" data-id="element-234" data-mp="1hh80rt6pk3sk">
          <div className="flex items-center justify-between gap-4" data-id="element-235" data-mp="2e0fdxxrf7w8x">
            <div data-id="element-236" data-mp="3fcjbqxrf9rge">
              <p className="text-[11px] font-medium uppercase tracking-[0.1em] text-cool" data-id="element-237" data-mp="3fc16jbms82wc">
                Desde
              </p>
              <p className="text-[19px] font-bold leading-tight text-ice" data-id="element-238" data-mp="3p1kpehahvwr7">
                $24.990 <span className="text-[12px] text-cool" data-id="element-239" data-mp="3p3nqpxh3lcb8">ARS</span>
              </p>
            </div>
            <button type="button" onClick={goToPricing} className="h-11 shrink-0 rounded-lg bg-gold px-6 text-[14px] font-bold uppercase tracking-[0.05em] text-ink shadow-[0_0_18px_rgba(255,159,28,0.35)] transition-colors duration-200 ease-smooth hover:bg-gold-warm" data-id="element-240" data-mp="3k8rok4i5d8ke">
              Ver planes
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}